import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=5f67b229&scoped=true&lang=pug"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"
import style0 from "./Link.styl?vue&type=style&index=0&id=5f67b229&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f67b229",
  null
  
)

export default component.exports